import { render } from "./LinkItem.vue?vue&type=template&id=42c27437"
import script from "./LinkItem.vue?vue&type=script&lang=js"
export * from "./LinkItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__